import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi', // default - only for display purposes
  },
  theme: {
    themes: {
      light: {
        main: '#212121',
        primary: '#EF5350',
        secondary: '#E3f6EC',
        accent: '#757575',
        error: '#FF9292',
        info: '#9E9E9E',
        success: '#4CAF50',
        warning: '#FFC107',
      }
    }
  }
});
